import { IS_DEVELOPMENT } from '../../../../envVars'

/**
 * @param pageWordingObj //wording object (워딩 시트에서 import한 개별 워딩 객체. ex. s_caf, s_pricing)
 * @param wordInfo // 워딩 정보
 * @returns
 */

interface WType {
  key: string[]
  params?: any[]
}
const findWordingKey = (pageWordingObj, wordInfo: WType) => {
  let wordingObj = pageWordingObj

  wordInfo.key.forEach((item) => {
    if (!wordingObj[item]) {
      wordingObj = IS_DEVELOPMENT ? wordInfo.key.join('.') + ':없는 키값입니다 🚨' : ''
    } else wordingObj = wordingObj[item]
  })
  if (typeof wordingObj === 'function') return wordingObj(...wordInfo.params)
  else return wordingObj
}

export default findWordingKey

export const useMapCAFTotalLevel = () => {
  const mapNumberToLevel = (level) => {
    // 0~4 : 1(하)
    // 5~6 : 2(중)
    // 7~9 : 3(상)
    if (level < 5) return 1
    if (level < 7) return 2
    if (level < 10) return 3
  }
  const returnCAFTotalLevel = (compArray) => {
    return compArray?.reduce((acc, cur) => {
      return acc + mapNumberToLevel(cur.level_rough)?.toString()
    }, '')
  }
  return { mapNumberToLevel, returnCAFTotalLevel }
}
